let state = {
    gameLoadingFinish: false,
}

// 创建改变状态的方法
const mutations = {
    CHANGE_GAME_LOADING_STATE: (state, gameLoadingFinish) => {
        state.gameLoadingFinish = gameLoadingFinish;
    }
}

const actions = {
    change_game_loading_state({ commit }, state) {
        commit('CHANGE_GAME_LOADING_STATE', state);
    },
}

// 输出store
export default {
    state,
    mutations,
    actions
};
